var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47CE72",
    fillRule: "evenodd",
    d: "M10 18.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5m5.267-10.748a.74.74 0 0 0 .2-.51.655.655 0 0 0-.222-.51.664.664 0 0 0-.488-.199.74.74 0 0 0-.51.2l-5.09 5.527-2.849-2.662a.74.74 0 0 0-.51-.2.663.663 0 0 0-.487.2.655.655 0 0 0-.222.51.74.74 0 0 0 .2.51l3.359 3.15a.74.74 0 0 0 .51.199.74.74 0 0 0 .51-.2l5.6-6.015Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.10e8b6babfee1235c746d877e35c76df.svg";